import React, { useEffect, useState } from "react";
import AuthNavBar from "./components/nav/AuthNav";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  userSelector,
  fetchUserBytoken,
  clearState,
} from "../features/User/UserSlice";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";

const Report = () => {
  const { t } = useTranslation();
  let history = useHistory();
  const showDialog = () => {
    Swal.fire({
      title: t("notice"),
      text: t("modification_fee_notice"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        history.push("/update");
      }
    });
  };

  const [details, setDetails] = useState([]);

  const user_id = localStorage.getItem("user_id");

  const [fetchdata, setFetchdata] = useState(true);
  useEffect(() => {
    let one = "https://idms-preenrol.e-citizen.org/api/v1/biodata/" + user_id;

    axios({
      method: "GET",
      url: `https://idms-preenrol.e-citizen.org/api/v1/enrolment/trackingId/${localStorage.getItem(
        "trackingId",
      )}`,

      // data: {
      //   sin: localStorage.getItem("trackingId"),
      // },
    })
      .then((res) => {
        console.log("res", res.data);
        setFetchdata(false);
        setDetails(res.data);
      })
      .catch((err) => {
        console.log("error in request", err);
      });
  }, []);

  const { isFetching, isError } = useSelector(userSelector);
  console.log("Details");
  console.log(details.firstName);

  return (
    <div>
      <AuthNavBar />
      {fetchdata ? (
        <center>
          <Loader type="ThreeDots" color="#00BFFF" height={100} width={100} />
        </center>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col card shadow p-3 mb-5 bg-white rounded">
              <div className="card-body">
                <h5
                  className="card-title"
                  style={{ color: "rgba(21, 202, 74, 0.78)" }}
                >{t("citizen_details")}</h5>
                <hr />
                <div className="row">
                  <div class="row">
                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label
                          for="exampleInputFirstName"
                          className="form-label"
                        >{t("first_name")}</label>
                        <input
                          className="form-control"
                          id="firstName"
                          name="firstName"
                          type="text"
                          value={details.firstName}
                          style={{ textTransform: "uppercase" }}
                          autocomplete="FirstName"
                        />
                      </div>
                    </div>
                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label
                          for="exampleInputLastName"
                          className="form-label"
                        >{t("surname")}</label>
                        <input
                          className="form-control"
                          id="lastName"
                          type="text"
                          name="lastName"
                          value={details.lastName}
                          style={{ textTransform: "uppercase" }}
                          autocomplete="lastName"
                        />
                      </div>
                    </div>

                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">{t("dob")}</label>
                        <input
                          type="date"
                          className="form-control"
                          aria-describedby="DOBHelp"
                          id="dobinputtype"
                          name="dob"
                          value={details.dob}
                        />
                      </div>
                    </div>
                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">{t("gender")}</label>
                        <input
                          className="form-control"
                          id="lastName"
                          type="text"
                          name="lastName"
                          value={details.gender}
                          style={{ textTransform: "uppercase" }}
                          autocomplete="lastName"
                        />
                      </div>
                    </div>

                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">{t("telephone_number")}</label>
                        <input
                          type="number"
                          maxlength="11"
                          placeholder="0XXXXXXXXXXX"
                          className="form-control"
                          id="exampleInputDOB"
                          style={{ textTransform: "uppercase" }}
                          name="phoneNumber"
                          value={details.phoneNumber}
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>
                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">{t("email")}</label>
                        <input
                          className="form-control"
                          id="email"
                          name="email"
                          type="text"
                          value={details.email}
                          style={{ textTransform: "uppercase" }}
                          autocomplete="Email"
                        />
                      </div>
                    </div>
                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">{t("maiden_name")}</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputDOB"
                          value={details.maidenName}
                          style={{ textTransform: "uppercase" }}
                          name="maidenName"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>
                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">{t("contact_owner")}</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputDOB"
                          value={details.contactOwner}
                          style={{ textTransform: "uppercase" }}
                          name="maidenName"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-3">
                    <h5
                      className="card-title p-2"
                      style={{ backgroundColor: "rgba(91, 230, 112, 0.23)" }}
                    >{t("residence_address_data")}</h5>
                  </div>
                  <div class="row">
                    <div class="col-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">{t("residence_address")}</label>
                        <textarea
                          className="form-control"
                          aria-label="With textarea"
                          name="residenceAddress"
                          id="residenceAddress"
                          value={details.residenceAddress}
                          style={{ textTransform: "uppercase" }}
                        ></textarea>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-5 col-lg-6">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">{t("residence_address_town")}</label>
                        <textarea
                          className="form-control"
                          aria-label="With textarea"
                          name="houseAddress"
                          style={{ textTransform: "uppercase" }}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-5 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label htmlFor="region" className="form-label">{t("region")}</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputDOB"
                          value={details.region}
                          style={{ textTransform: "uppercase" }}
                          name="maidenName"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-5 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label htmlFor="district" className="form-label">{t("district")}</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputDOB"
                          value={details.district}
                          style={{ textTransform: "uppercase" }}
                          name="maidenName"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-5 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label htmlFor="commune" className="form-label">{t("province")}</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputDOB"
                          value={details.province}
                          style={{ textTransform: "uppercase" }}
                          name="maidenName"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-5 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">{t("place_of_birth")}</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputDOB"
                          value={details.placeOfBirth}
                          style={{ textTransform: "uppercase" }}
                          name="maidenName"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Report;
